import { render } from "./SaveOAuthClient.vue?vue&type=template&id=448a8c62&scoped=true"
import script from "./SaveOAuthClient.vue?vue&type=script&lang=js"
export * from "./SaveOAuthClient.vue?vue&type=script&lang=js"

import "./oauth-client.scss?vue&type=style&index=0&id=448a8c62&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\Utilizador\\Desktop\\projetos\\owlpharma-hrm\\src\\client\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-448a8c62"]])

export default __exports__